import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationGivingAccountEnvelope, UpdateOrganizationGivingAccountParams } from './types';

export async function updateOrganizationGivingAccount(
  organizationId: string,
  params: UpdateOrganizationGivingAccountParams
) {
  const url = `/web/studio/organizations/${organizationId}/giving-account`;

  /* eslint-disable camelcase */
  const body: Record<string, unknown> = {};

  if (params.manuallyDisableGiving !== undefined) body.manually_disable_giving = params.manuallyDisableGiving;
  if (params.extraGivingEmail !== undefined) body.extra_giving_email = params.extraGivingEmail;
  /* eslint-enable camelcase */

  const response = await api.executePutRequest<ObjectResponse<OrganizationGivingAccountEnvelope>>(url, body);

  return response.data;
}
